import { z } from 'zod';

export const stationsSchema = z.object({
  stations: z.array(
    z.object({
      id: z.string().nullable().optional(),
      name: z
        .string()
        .min(1, 'Name is required')
        .max(50, 'Name cannot exceed 50 characters'),
      accessTypeIds: z
        .array(z.string())
        .min(1, 'At least one type is required'),
    })
  ),
});
